<template>
  <div :class="classes">
    <slot />

    <div v-if="loading" :class="$style.overlay">
      <ui-spinner :theme :size />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useCssModule, computed } from 'vue'
import UiSpinner from './index.vue'
import type { BaseProps } from './types'

interface Props extends BaseProps {
  loading?: boolean
  translucent?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  theme: 'default',
  size: '4em',
  loading: false,
  translucent: false
})

defineSlots<{
  default(slotProps: Record<string, never>): any
}>()

const cssModule = useCssModule()

const classes = computed(() => [
  cssModule.container,
  {
    [cssModule.loading]: props.loading,
    [cssModule.translucent]: props.translucent
  }
])
</script>

<style lang="scss" module>
.container {
  position: relative;

  &.translucent {
    > :not(.overlay) {
      transition-property: opacity;
      transition-duration: var(
        --root-spinner-overlay-translucent-children-transition-duration
      );
      transition-timing-function: var(
        --root-spinner-overlay-translucent-children-transition-timing-function
      );
    }

    .overlay {
      background: transparent;
    }

    &.loading {
      > :not(.overlay) {
        opacity: var(
          --root-spinner-overlay-translucent-loading-children-opacity
        );
      }
    }
  }
}

.overlay {
  border-radius: inherit;
  position: absolute;
  inset: 0;
  z-index: var(--root-spinner-overlay-z-index);
  background: var(--root-spinner-overlay-bg);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
